          
<template>
  <router-link class="news__items-item" :to="href">
    <div class="news__item-thumbnail-text">
      <h3 class="news__item-thumbnail-title">
        {{ newsItem.title }}
      </h3>
      <span class="news__item-thumbnail-date">{{
        date.format(new Date(newsItem.created), "DD-MM-YYYY")
      }}</span>
    </div>
    <div
      v-if="
        !newsItem?.images ||
        (Array.isArray(newsItem.images) &&
          !newsItem.images.find((i) => i.isThumbnail))
      "
      class="news__items-thumnail-placeholder"
    ></div>
    <responsive-img
      v-if="
        Array.isArray(newsItem.images) &&
        newsItem.images.find((i) => i.isThumbnail)
      "
      class="news__items-thumnail"
      :imgId="newsItem.images.find((i) => i.isThumbnail).id"
      :imgType="'newsThumbnail'"
      :imgAlt="newsItem.images.find((i) => i.isThumbnail).alt"
    />
  </router-link>
</template>

<script>
import ResponsiveImg from "./ResponsiveImg.vue";
import date from "date-and-time";

export default {
  components: { ResponsiveImg },
  props: {
    href: String,
    newsItem: {},
  },
  setup() {
    return {
      date,
    };
  },
};
</script>